module.exports = {"320813001":"高良涧街道","320813002":"朱坝街道","320813003":"黄集街道","320813101":"蒋坝镇","320813103":"岔河镇","320813104":"西顺河镇","320813105":"老子山镇","320813106":"三河镇","320813110":"东双沟镇","320813400":"洪泽经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320813.json
// module id = 998
// module chunks = 0